import ReviewerReviewContext from '../ReviewerReviewContext'
import BugTable from './BugTable'
import { useGetSessionReviewerBugsInfiniteQuery } from '../../services/sessionReviewersApi'

export default function ReviewerBugList({ projectId, reviewer }: { projectId: string; reviewer: string }) {
  const query = useGetSessionReviewerBugsInfiniteQuery({ projectId, reviewer }, { pollingInterval: 30000, skipPollingIfUnfocused: true })
  const nextPageError = query.isError && query.direction === 'forward'
  const data = query.currentData
  const total = data?.pages[0]?.total ?? 0
  const bugs = [...new Map((data?.pages.flatMap(page => page.bugs) ?? []).map(bug => [bug.id, bug])).values()]
  const reviews = new Map(data?.pages.flatMap(page => Object.entries(page.reviews)) ?? [])
  if (!query.isError && (!data || total === 0)) return null
  return <section aria-label="Reviewer bugs" className="session-reviewers__bugs">
    <h2 className="project-tab-section-title">Bugs{data ? ` (${total})` : ''}</h2>
    {data && <BugTable bugs={bugs} projectId={projectId} loading={false} hasWebhook={false} showEnvironment={false} renderDetails={bug => <details className="session-reviewers__bug-review">
      <summary>Associated reviews ({reviews.get(bug.id)?.length ?? 0})</summary>
      {reviews.get(bug.id)?.map(review => <ReviewerReviewContext key={review.id} projectId={projectId} review={review} />)}
    </details>} />}
    {(query.hasNextPage || query.isError) && <div className="session-reviewers__bug-footer">
      {query.isError && <p role="alert">{nextPageError ? 'Could not load more bugs.' : 'Could not load reviewer bugs.'}</p>}
      <button
        type="button"
        className="session-reviewers__bug-load-more"
        disabled={query.isFetching}
        onClick={() => void (query.isError && !nextPageError ? query.refetch() : query.fetchNextPage())}
        data-testid="reviewer-bugs-load-more"
      >
        {query.isFetchingNextPage ? 'Loading…' : query.isError ? 'Retry' : 'Load more'}
      </button>
    </div>}
    {data && <p className="session-reviewers__bug-count" role="status">Showing {bugs.length} of {total} bugs</p>}
  </section>
}
